import { GTMolecularExportFn } from "../../components/GTMolecularExportFn";

const FN_NAME = "gtm-export-seq-selection";

function FnRun() {
  return <GTMolecularExportFn name={FN_NAME} />;
}

export { FnRun };
